import { Injectable } from '@angular/core';
import { from } from 'rxjs';
import { map } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import * as CryptoJS from 'crypto-js';
@Injectable({
  providedIn: 'root'
})
export class AppService {
  configUrl = window.location.pathname + 'assets/app.config.json';
  constructor() { }
  load() {
    return from(
      fetch(this.configUrl).then((response: any) => {
        return response.json()
      })
    )
      .pipe(
        map((data) => {
          environment.BASEURL = CryptoJS.AES.decrypt(
            data.BASEURL, environment.ENCRYPTKEY
          ).toString(CryptoJS.enc.Utf8)
            ;
          
          environment.API = CryptoJS.AES.decrypt(
            data.API, environment.ENCRYPTKEY
          ).toString(CryptoJS.enc.Utf8);
          environment.CLIENT_ID = CryptoJS.AES.decrypt(
            data.CLIENT_ID, environment.ENCRYPTKEY
          ).toString(CryptoJS.enc.Utf8);

          environment.AUTHORITY = CryptoJS.AES.decrypt(
            data.AUTHORITY, environment.ENCRYPTKEY
          ).toString(CryptoJS.enc.Utf8);

          environment.FILE_SIZE = +data.FILE_SIZE;
        })

      ).toPromise()
  }
}
